import { postAPI } from '@shared/api/external-api'
import type { AuthResponse } from '@shared/types/login'

export const refreshToken = async (accessToken: string) => {
  return await postAPI<AuthResponse>(`/renew-token`, {}, { accessToken })
}
